import { useMemo, useState } from "react";
import { getApplicationUsersApi } from "../../../services/apis/applicationUserApis";
import { toastError } from "../../../utils/toastUtils";

const useOrgUsers = (orgId) => {
  const [allOrgUsers, setAllOrgUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchUsers = async (signal) => {
    try {
      setIsLoading(true);

      const response = await getApplicationUsersApi({ orgId, signal });
      const data = response?.data;

      setAllOrgUsers(data || []);
    } catch (error) {
      if (error.name === "CanceledError") return;

      toastError(error?.response?.data?.message || error?.response?.data?.error || "Failed to fetch users");
    } finally {
      setIsLoading(false);
    }
  };

  const userOptions = useMemo(
    () =>
      allOrgUsers.map((user) => ({
        value: user._id,
        label: user.email,
        user
      })),
    [allOrgUsers]
  );

  return { userOptions, isLoading, fetchUsers };
};

export default useOrgUsers;
